'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const ListingsTrendChart = dynamic(() => import('./ListingsTrendChart'), { ssr: false });
const PropertyTypeChart = dynamic(() => import('./PropertyTypeChart'), { ssr: false });

export default function AdminCharts() {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-2 gap-6 mt-6">
      <div className="bg-card border border-border rounded-2xl p-6 shadow-card">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="font-bold text-foreground text-base">Monthly Listings Growth</h3>
            <p className="text-muted-foreground text-xs mt-0.5">New listings added per month — 2025/2026</p>
          </div>
        </div>
        <ListingsTrendChart />
      </div>
      <div className="bg-card border border-border rounded-2xl p-6 shadow-card">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="font-bold text-foreground text-base">Listings by Property Type</h3>
            <p className="text-muted-foreground text-xs mt-0.5">Distribution across property categories</p>
          </div>
        </div>
        <PropertyTypeChart />
      </div>
    </div>
  );
}